import React, { useCallback } from 'react';
import { Keyboard, TextInput } from 'react-native';
import { useActionSheet } from 'hooks/useActionSheet';
import { useWaitingNavigation } from 'utils/types/navigationV6';
import { HelpNavigationButton } from 'design-system/TextButton';
const HelpButton = ({ black }) => {
    const nav = useWaitingNavigation();
    const actionSheet = useActionSheet();
    const onPress = useCallback(() => {
        // The action sheet takes the focus from a text input, and when it closes iOS
        // gives it back while the sheet is still on screen, so a button that follows
        // the keyboard jumps. Close the keyboard first and focus the input again once
        // the sheet has gone.
        const focusedInput = TextInput.State.currentlyFocusedInput();
        if (focusedInput) {
            Keyboard.dismiss();
        }
        actionSheet.showActionSheetWithOptions({
            options: ['Chat with a human', 'Cancel'],
            cancelButtonIndex: 1,
        }, (i) => {
            if (i === 0) {
                nav.navigateDeprecated('Support', { isWaitingScreen: true });
            }
            else if (focusedInput) {
                TextInput.State.focusTextInput(focusedInput);
            }
        });
    }, [actionSheet, nav]);
    return <HelpNavigationButton onPress={onPress} black={black}/>;
};
export default HelpButton;
